<div class="dialog confirm-dialog" *ngIf="showDialog">
  <mat-icon
    *ngIf="showCloseButton"
    class="dialog__close"
    aria-hidden="false"
    aria-label="Close icon"
    (click)="onClose()"
    >close</mat-icon
  >
  <div mat-dialog-title>
    <h1>{{ data.title }}</h1>
  </div>
  <div mat-dialog-content class="confirm-container">
    <div class="viewmode">
      <mat-icon><em class="fa fa-exclamation-triangle"></em></mat-icon>
      <div class="alert-msgs">
        <span class="message">{{ data.message }}</span>
        <div *ngIf="data.rememberMyChoiceDialogId">
          <mat-checkbox [(ngModel)]="rememberChoice">
            {{ data.doNotRemindMeText }}
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div mat-dialog-actions class="confirm-dialog-actions">
      <ng-container *ngIf="data.cancelText">
        <button mat-button color="primary" (click)="selectOption(false)">
          {{ data.cancelText }}
        </button>
      </ng-container>
      <ng-container *ngIf="data.confirmText">
        <button mat-flat-button color="primary" (click)="selectOption(true)" cdkFocusInitial>
          {{ data.confirmText }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
